import { PropertyObjectTypes, PropertyObjectTypesIds } from 'FormsCommonComponents/constants/PropertyObjectTypes';
export const isContactProperty = objectTypeId => objectTypeId === PropertyObjectTypesIds[PropertyObjectTypes.CONTACT];
export const isCompanyProperty = objectTypeId => objectTypeId === PropertyObjectTypesIds[PropertyObjectTypes.COMPANY];
export const isTicketProperty = objectTypeId => objectTypeId === PropertyObjectTypesIds[PropertyObjectTypes.TICKET];
export const isFeedbackProperty = isContactProperty;
export const getObjectTypeIdIdentifiersFromPropertyObjectTypeIdentifiers = fieldIdentifiers => {
  return fieldIdentifiers.map(fieldIdentifier => {
    const [potentialPropertyObjectTypeId, fieldName] = fieldIdentifier.split('-');
    if (PropertyObjectTypesIds[potentialPropertyObjectTypeId]) {
      return `${PropertyObjectTypesIds[potentialPropertyObjectTypeId]}/${fieldName}`;
    }
    return fieldIdentifier;
  });
};